// Una picture ha un file mostrabile?
//
// L'API ha restituito a lungo l'immagine in base64 nel campo `image`; ora
// restituisce il solo booleano `has_image` e il file si prende via IIIF su
// /iiif/2/<picture_id>. Accettare entrambe le forme rende il frontend
// indipendente dall'ordine di rilascio: contro l'API vecchia `has_image` e
// undefined e si ricade sulla presenza di `image`, senza che le immagini
// spariscano nell'intervallo fra i due deploy.
export const hasPicture = (picture) => {
  if (!picture) {
    return false;
  }
  return picture.has_image !== undefined ? picture.has_image : !!picture.image;
};
